import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
export default {
  props: {
    title: {
      type: String,
      default: 'icon-card-title'
    },
    icon: {
      type: String,
      default: 'iconsminds-clock'
    },
    value: {
      type: Number,
      default: 0
    }
  }
};